import { EnumSchema } from '../metadata-schema';

export const OnderwijspositieUitzondering: EnumSchema = {
	"type": "string",
	"title": "OnderwijspositieUitzondering",
	"enum": [
		"Reguliere onderwijspositie",
		"Andere school/vestiging in leerjaar 1",
		"Doublure in lj 2",
		"Geen leerjaar 2",
		"Advies breder dan 3",
		"Uitgesloten van ROD-communicatie",
		"Tussentijdse in/uitstroom",
		"VSO advies",
		"Combinatieleerweg",
		"Internationale leerling",
		"PrO-leerling",
		"VAVO leerling",
		"Emigratie",
		"Nieuwkomer",
		"Uitstroom speciaal onderwijs",
		"Uitstroom/Geen VO"
	]
};
